import React from 'react';

import { AppLink, routeNaming } from '../../routes';
import { Footer } from '../../common/footer';
import { HomeNavbar } from '../../common/home-navbar';
import { PrimaryButton } from '../../common/primary-button';
import notFoundImage from './not-found.svg';
import styles from './NotFound.css';

const NotFound = () => (
  <div className={styles.container}>
    <HomeNavbar />
    <div className={styles.mainWrapper}>
      <div className={styles.mainContent}>
        <div className={styles.textContainer}>
          <h1 className={styles.title}>
            Algo no está bien...
          </h1>
          <p className={styles.subtext}>
            No podemos encontrar la página que estás buscando. Verifica
            la dirección o dirígete a nuestra página principal.
          </p>
          <p className={styles.errorCode}>
            Código de error: 404
          </p>
          <PrimaryButton
            className={styles.button}
          >
            <AppLink
              className={styles.buttonLink}
              routeName={routeNaming.HOME}
            >
              Página Principal
            </AppLink>
          </PrimaryButton>
        </div>
        <div className={styles.imageContainer}>
          <img src={notFoundImage} alt="" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export { NotFound };



// WEBPACK FOOTER //
// ./src/pages/not-found/NotFound.jsx